export default __webpack_public_path__ + "static/media/computerlab1.bc2db551.jpg";